import {
  Component,
  OnInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { DataService } from "./data.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import { WidgetConfig } from "../../../class/widget-config";
import * as HSET from "./settings";
import { GenericUtils } from './../../../utilities/generic-utils';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: 'widget-line-chart',
  templateUrl: './widget-line-chart.component.html',
  styleUrls: ['./widget-line-chart.component.scss'],
  providers: [DataService]
})
export class WidgetLineChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() FILTERS;
  @Input() WIDGETCONFIG: WidgetConfig;
  @Input() CHARTCONFIG;

  highcharts: typeof Highcharts = Highcharts;

  chartOptions = this.genericUtils.deepCopyFunction(HSET.chartData);

  errorMessage = "";
  mockChart = null;
  loadingChart = true;
  errorLoadingChart = false;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private translateService: TranslateService,
    private dataService: DataService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService,
    private genericUtils: GenericUtils
  ) { }

  ngOnChanges(changes: SimpleChanges) {

    this.getData();

  }

  ngOnInit() {
    this.translateService
      .get("PERFORMANCE.TRANSFER.REASON_FOR_FAILURE")
      .subscribe(text => {
        this.WIDGETCONFIG.title = this.WIDGETCONFIG.title || text;
      });
    this.broadcaster.listen("PAGE_WIDGET_DATA").pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.setWidgetData();
    });
  }
  setWidgetData() {
    if (!this.CHARTCONFIG[0].noTarget) {
      const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
      if (pageData) {
        pageData.forEach(element => {
          if (element.widget_id === this.WIDGETCONFIG.id) {
            this.setTarget(element.target);
          }
        });
      }
    }

  }

  setTarget(t) {
    if (this.chartOptions && !this.loadingChart) {
      this.chartOptions.series[2].data = [];
      for (let i = 0; i < this.chartOptions.series[0].data.length; i++) {
        this.chartOptions.series[2].data.push(t);
      }
    }
  }

  getData() {
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;
    this.errorLoadingChart = false;


    this.dataService
      .getData(this.WIDGETCONFIG.api, this.FILTERS, this.WIDGETCONFIG)
      .subscribe(
        chartData => {
          this.loadingChart = false;

          if (chartData) {
            this.chartOptions = this.dataService.createChart(
              chartData,
              this.CHARTCONFIG
            );
            this.setWidgetData();
          } else {
            this.handleError("ERROR_MSG.NO_DATA");
          }
          this.loadingChart = false;

        },
        error => {
          this.loadingChart = false;
          this.handleError("ERROR_MSG.NO_DATA");
        }
      );
  }

  handleError(message) {
    this.errorLoadingChart = true;
    this.errorMessage = message;
    this.mockChart = [{ chart: HSET.chartData, width: 12 }];

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}